import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { eq, and } from "drizzle-orm";
import z from "zod";
import { auth } from "~/lib/better-auth/auth";
import { db } from "~/db";
import { locationsToUsers } from "~/db/schema";

export const checkLocationOwnership = createServerFn({ method: "GET" })
  .inputValidator(z.number())
  .handler(async (ctx) => {
    const locationId = ctx.data;
    const request = getRequest();

    if (!request?.headers) {
      return false;
    }

    const userSession = await auth.api.getSession({ headers: request.headers });

    if (!userSession) {
      return false;
    }

    // Check if user owns this location
    const userLocation = await db
      .select()
      .from(locationsToUsers)
      .where(
        and(
          eq(locationsToUsers.locationId, locationId),
          eq(locationsToUsers.userId, userSession.user.id)
        )
      )
      .limit(1)
      .execute();

    return userLocation.length > 0;
  });
